import React from 'react';
import './../../../../../style/Vars.css';
import './../../../../../style/ContainersStyles.css';
import './../../../../../style/ElementsStyle.css';
import '../../../Styles/LmsExtra.css';
import AdministrarCarrerasCatalog from './AdministrarCarrerasCatalog';

export default function AdministrarCarrerasPage() {
    return <AdministrarCarrerasCatalog />;
}
